import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

const initializePdfMake = () => {
  if (!window.pdfMake) throw new Error('ไม่พบระบบสร้าง PDF');
  window.pdfMake.fonts = {
    THSarabunNew: {
      normal: 'THSarabunNew.ttf',
      bold: 'THSarabunNew Bold.ttf',
      italics: 'THSarabunNew Italic.ttf',
      bolditalics: 'THSarabunNew BoldItalic.ttf'
    }
  };
};

const number = value => Number(value || 0).toLocaleString('th-TH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const amountCell = (value, bold = false) => ({
  text: number(value), alignment: 'right', bold, noWrap: true, margin: [0, 3, 0, 3]
});

const headerCell = (text, options = {}) => ({
  text,
  bold: true,
  alignment: options.alignment || 'center',
  rowSpan: options.rowSpan,
  colSpan: options.colSpan,
  fillColor: '#f7f7f7',
  margin: [0, options.rowSpan ? 10 : 4, 0, 4]
});

const sum = (rows, field) => rows.reduce((total, row) => total + Number(row[field] || 0), 0);

const createBody = rows => {
  const totals = {
    openingDebit: sum(rows, 'opening_debit'),
    openingCredit: sum(rows, 'opening_credit'),
    debit: sum(rows, 'total_debit'),
    credit: sum(rows, 'total_credit'),
    closingDebit: sum(rows, 'closing_debit'),
    closingCredit: sum(rows, 'closing_credit')
  };

  return [
    [
      headerCell('ชื่อบัญชี', { rowSpan: 2, alignment: 'left' }),
      headerCell('รหัสบัญชี', { rowSpan: 2, alignment: 'left' }),
      headerCell('ยอดยกมา', { colSpan: 2 }), {},
      headerCell('งวด', { colSpan: 2 }), {},
      headerCell('คงเหลือ', { colSpan: 2 }), {}
    ],
    [
      {}, {},
      headerCell('เดบิต'), headerCell('เครดิต'),
      headerCell('เดบิต'), headerCell('เครดิต'),
      headerCell('เดบิต'), headerCell('เครดิต')
    ],
    ...rows.map(row => ([
      { text: row.name || '-', margin: [0, 3, 0, 3] },
      { text: row.code || '-', margin: [0, 3, 0, 3], noWrap: true },
      amountCell(row.opening_debit), amountCell(row.opening_credit),
      amountCell(row.total_debit), amountCell(row.total_credit),
      amountCell(row.closing_debit), amountCell(row.closing_credit)
    ])),
    [
      { text: 'ยอดรวม', colSpan: 2, bold: true, fillColor: '#f7f7f7', margin: [0, 4, 0, 4] },
      {},
      { ...amountCell(totals.openingDebit, true), fillColor: '#f7f7f7' },
      { ...amountCell(totals.openingCredit, true), fillColor: '#f7f7f7' },
      { ...amountCell(totals.debit, true), fillColor: '#f7f7f7' },
      { ...amountCell(totals.credit, true), fillColor: '#f7f7f7' },
      { ...amountCell(totals.closingDebit, true), fillColor: '#f7f7f7' },
      { ...amountCell(totals.closingCredit, true), fillColor: '#f7f7f7' }
    ]
  ];
};

export const createTrialBalanceDefinition = ({ rows, company, period }) => {
  const companyName = company?.company_name || company?.name || 'ชื่อกิจการ';
  const startDate = dayjs(period[0]);
  const endDate = dayjs(period[1]);
  const startYear = startDate.year() + 543;
  const endYear = endDate.year() + 543;
  const startLabel = `${startDate.format('D MMMM')} ${startYear}`;
  const endLabel = `${endDate.format('D MMMM')} ${endYear}`;

  return {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [8, 14, 8, 28],
    defaultStyle: { font: 'THSarabunNew', fontSize: 8.5, color: '#111111' },
    footer: (currentPage, pageCount) => ({
      text: `หน้า ${currentPage}/${pageCount}`,
      alignment: 'right',
      margin: [0, 5, 8, 0],
      fontSize: 8
    }),
    content: [
      { text: companyName, alignment: 'center', bold: true, fontSize: 15 },
      { text: 'งบทดลอง', alignment: 'center', bold: true, fontSize: 14 },
      { text: `ระหว่างวันที่ ${startLabel} ถึง ${endLabel}`, alignment: 'center', fontSize: 11, margin: [0, 0, 0, 7] },
      { text: '(หน่วย : บาท)', alignment: 'right', fontSize: 8.5, margin: [0, 0, 0, 2] },
      {
        table: {
          headerRows: 2,
          dontBreakRows: true,
          widths: [120, 48, 58, 58, 58, 58, 58, 58],
          body: createBody(rows)
        },
        layout: {
          hLineWidth: () => 0.45,
          vLineWidth: () => 0.35,
          hLineColor: () => '#dedede',
          vLineColor: () => '#e6e6e6',
          paddingLeft: () => 3,
          paddingRight: () => 3,
          paddingTop: () => 0,
          paddingBottom: () => 0
        }
      }
    ]
  };
};

export const generateTrialBalancePdf = payload => {
  initializePdfMake();
  const generator = window.pdfMake.createPdf(createTrialBalanceDefinition(payload));
  return new Promise((resolve, reject) => {
    try {
      generator.getDataUrl(resolve);
    } catch (error) {
      reject(error);
    }
  });
};
